export function api_path() {
    //return "http://localhost/fertnutri.api/";
    return "https://www.fertnutri.agr.br/api/";
  }

  export function banner_path() {
    //return "http://localhost/fertnutri.gerenciador/banners/media/";
    return "https://gerenciador.fertnutri.agr.br/banners/media/";
  }